import React from 'react';

import './VirtualTour.scss';
import Modal from '../Modal/Modal';
import { DEFAULT_TOUR } from '../../utils/constants';

const VirtualTour = ({ onClose, tourUrl }) => (
  <Modal>
    <div className="virtual-tour">
      <button className="virtual-tour__close" onClick={() => onClose()} />
      <iframe
        src={tourUrl}
        allow="vr"
        allowFullScreen
        frameBorder="0"
        title="Virtual Tour"
        className="virtual-tour__iframe"
      ></iframe>
    </div>
  </Modal>
);
VirtualTour.defaultProps = {
  tourUrl: DEFAULT_TOUR,
};

export default VirtualTour;
